<template>
	<div>
		<h2>{{ item.title }}</h2>

		<label v-bind="{ for: 'i' + item.id + '_1' }">
			<b>
				<u>{{ item.text }}</u>
			</b>
		</label>
		<!-- <small v-if="!item.overrideTxtMsg && item.type !== 'small' && item.type !== 'medium'">({{ coronaMsg[lang] }})</small> -->
		<input v-if="item.type === 'small'" @blur="textBlur" class="small" type="text" v-bind="{ name: 'i' + item.id, id: 'i' + item.id + '_1' }" v-model="response.value" />
		<input v-else-if="item.type === 'medium'" @blur="textBlur" class="medium" type="text" v-bind="{ name: 'i' + item.id, id: 'i' + item.id + '_1' }" v-model="response.value" />
		<textarea v-else @blur="textBlur" class="freitext" v-bind="{ name: 'i' + item.id, id: 'i' + item.id + '_1' }" rows="3" v-model="response.value"></textarea>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	name: "txt",
	props: {
		item: Object,
	},
	data() {
		return {
			response: {
				id: this.item.id,
				value: "",
			},
		};
	},
	methods: {
		textBlur() {
			this.$emit("add:response", this.response);
		},
	},
	computed: mapGetters(["lang", "coronaMsg"]),
};
</script>

<style scoped>
h2 {
	font-weight: 600;
	margin-bottom: 0.5rem;
}
div {
	display: flex;
	flex-direction: column;
	margin-bottom: 0.8rem;
}
small {
	font-size: 0.8rem;
}
label {
	margin-bottom: 0.2rem;
}

.small {
	width: 10%;
	min-width: 100px;
}
.medium {
	width: 25%;
	min-width: 200px;
}
</style>
